import { Flex } from "Element/Flex";
import React from "react";
import { dogeImgList } from "../dogeList";
import { DogeImg, StyledHeroText } from "../styled";
import Scholarship from "./Scholarship";
import {
  ScholarContainer,
  CarouselWrapper,
  Description,
  AboutWrapper,
  RunningImg,
  AboutContainer,
} from "./styled";
import Waves from "./Waves";

const About = () => {
  return (
    <>
      <AboutWrapper>
        <AboutContainer>
          <StyledHeroText>What's Doge NFT</StyledHeroText>
          <Flex flexDirection="column">
            <Description>
              Doge is a collection of 10,000 randomly generated NFTs in the
              likeness of the one and only shiba inu Doge dog. They come in many
              flavors and distinct personalities, and represent membership to
              the Doge kennel.
            </Description>
            <Description>
              We aim to bring in non-crypto-native people and educate them about
              the NFT gaming landscape. Community membership opens access to our
              network of investors, gamers and social media influencers.
            </Description>
          </Flex>
        </AboutContainer>
        <CarouselWrapper
          flexWrap="nowrap"
          flexGrow={1}
          alignItems="flex-end"
          justifyContent="center"
          width="100%"
        >
          <RunningImg />
        </CarouselWrapper>
      </AboutWrapper>
      <ScholarContainer id="about">
        <Flex flexDirection="column" height="100%">
          <Scholarship />
          <Waves />
        </Flex>
      </ScholarContainer>
    </>
  );
};

export default About;
